import _ from "lodash";
import { FolderStructure, FolderItemType } from "../Primitive/TreeStructure";
// ------------------------------------------------------------------------------------------------------
export function buildPathFromStructure(structure: FolderStructure[], path: string): FolderStructure[] {
    _.forEach(structure, element => {
        if (element.type != FolderItemType.Folder) {
            element.path = path;
        }
        else if (element.children.length > 0) {
            element.children = buildPathFromStructure(element.children, path + element.primaryText + "/");
        }
    });
    return structure;
}
// ------------------------------------------------------------------------------------------------------
function cleanEmptyFolders(folders: FolderStructure[]): FolderStructure[] {
    // Go to the children and do the same !!!
    for (var f of folders)
        if (f.type == FolderItemType.Folder)
            f.children = cleanEmptyFolders(f.children);

    // Now that we go to the depth of folders start delete empty folders
    _.remove(folders, x => (x.type == FolderItemType.Folder) && (x.children == null || x.children.length == 0));
    return folders;
}
// ------------------------------------------------------------------------------------------------------
export function buildStructureFromPath(arr: FolderStructure[]): FolderStructure[] {
    var tree: FolderStructure[] = [];

    // First map the nodes of the array to an object -> create a hash table.
    var mappedArr = _.keyBy(arr, "_id");

    // Reset children element
    _.forOwn(mappedArr, (v, k) => {
        v.children = [];
    });

    // Mapped the elements
    _.forOwn(mappedArr, (v, k) => {
        // If the element is not at the root level, add it to its parent array of children.
        if (v.parentId) {
            mappedArr[v.parentId].children.push(v);
        }
        // If the element is at the root level, add it to first level elements array.
        else {
            tree.push(v);
        }
    });

    return cleanEmptyFolders(tree);
}
// ------------------------------------------------------------------------------------------------------
export interface FolderFlatList {
    key: string;
    label: string;
    path: string;
    order: number;
    undeletePage: boolean;
}
// ------------------------------------------------------------------------------------------------------
function createFlatListRecurrent(folders: FolderStructure[], order: number): { list: FolderFlatList[], order: number } {
    let list: FolderFlatList[] = [];
    _.forEach(folders, (f) => {
        if (f.type == FolderItemType.Dashboard) {
            list.push({
                key: f.key,
                label: f.primaryText,
                path: f.path,
                order: order,
                undeletePage: f.undeletePage
            });
            order++;
        } else if (f.children.length > 0) {
            let l = createFlatListRecurrent(f.children, order);
            order = l.order;
            list.push(...l.list);
        }
    });

    return { list, order };
}
// ------------------------------------------------------------------------------------------------------
export function createFlatList(folders: FolderStructure[]): FolderFlatList[] {
    let l = createFlatListRecurrent(folders, 0);
    return l.list;
}
// ------------------------------------------------------------------------------------------------------